<div class="container">
  <div class="content-wrapper">
    @if (showFail()) {
      <div class="alert alert-danger">
        Signup failed, Please enter required field
      </div>
    }

    <div class="row mt-4">
      <!-- LEFT: LOGIN IMAGE -->
      <div class="col-lg-6 col-md-6">
        <div id="demo" class="carousel slide" data-ride="carousel">
          <ul class="carousel-indicators">
            <li data-target="#demo" data-slide-to="0" class="active"></li>
          </ul>

          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                src="assets/images/image-regular/login01.jpg"
                alt="Los Angeles"
                width="1100"
                height="500"
              />

              <div class="carousel-caption">
                <h3 class="white">Your Travel Booking</h3>
              </div>
            </div>
          </div>

          <a class="carousel-control-prev" href="#demo" data-slide="prev">
            <span class="carousel-control-prev-icon"></span>
          </a>

          <a class="carousel-control-next" href="#demo" data-slide="next">
            <span class="carousel-control-next-icon"></span>
          </a>
        </div>
      </div>

      <!-- RIGHT: LOGIN -->
      <div class="col-lg-6 col-md-6">
        <div class="tab-content">
          <div
            role="tabpanel"
            class="tab-pane padding-0 active"
            id="loginTabInDropdown01-01s"
          >
            <div class="scene scene--card">
              <!-- ===================================================== -->
              <!-- LOGIN CARD -->
              <!-- ===================================================== -->

              @if (showlogin() && !showreset()) {
                <div #forgot class="card">
                  @if (forgotPassword()) {
                    <!-- SOCIAL LOGIN -->
                    <div class="row pl-20 pr-20 ytb-login">
                      <div class="text-center col-md-12">
                        <h4 class="font24 font600 opensans mt-10">
                          Sign In with:
                        </h4>

                        <p>
                          Connect with your favorite social media platform for a
                          quicker sign-in experience
                        </p>
                      </div>
                    </div>

                    <div class="row m-0 gap-5">
                      <!-- GOOGLE -->
                      <div class="col-md-6 input-options">
                        <div class="login-with-socials">
                          <button type="button" class="btn-block font13">
                            <div
                              #googleBtnContainer
                              id="googleBtnContainer"
                            ></div>
                          </button>
                        </div>
                      </div>

                      <!-- FACEBOOK -->
                      <div class="col-md-6 input-options">
                        <div class="login-with-socials">
                          <button
                            type="button"
                            class="btn btn-facebook btn-block font13"
                            (click)="loginwithGoogle('facebook')"
                          >
                            <i class="fab fa-facebook-f"></i>
                            Facebook
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- DESCRIPTION -->
                    <h3 class="mb-15 ml-1-enq mr-3">
                      Unlock Your Travel World!
                    </h3>

                    <p class="ml-1-enq mb-10 mr-2 text-justify">
                      Welcome to Your Travel Booking, where every click brings
                      you closer to a world of seamless bookings and exclusive
                      travel experiences. The journey begins with your sign-in,
                      opening the door to a personalized realm of adventure.
                      Your account not only streamlines your travel planning but
                      also unveils a treasure trove of exclusive deals and
                      member-only perks. Sign in now to embark on a hassle-free
                      exploration of the globe, as we turn your travel dreams
                      into reality!
                    </p>

                    <!-- LOGIN FORM -->
                    <form
                      [formGroup]="loginForm"
                      class="form-login"
                      (ngSubmit)="submitLogin()"
                    >
                      <div class="form-inner">
                        <!-- ERROR MESSAGES -->
                        @if (showErrorMessage() && errorMessageInfo().length) {
                          @for (err of errorMessageInfo(); track $index) {
                            <div class="row alert alert-danger">
                              {{ err }}
                            </div>
                          }
                        }

                        <!-- SUCCESS MESSAGES -->
                        @if (
                          showSuccessMessage() && errorMessageInfo().length
                        ) {
                          @for (err of errorMessageInfo(); track $index) {
                            <div class="alert alert-success">
                              {{ err }}
                            </div>
                          }
                        }

                        <br />

                        <!-- RESEND CONFIRMATION EMAIL -->
                        @if (isConfirmationEmail()) {
                          <button
                            type="button"
                            class="btn btn-primary btn-block font15"
                            (click)="resendEmailConfirmation()"
                          >
                            Click Here To Resend Email Confirmation
                          </button>
                        }

                        <!-- USER ID -->
                        <div class="form-group ytb-lgn">
                          <label
                            for="userId"
                            class="form-label fmlab-bg black left"
                          >
                            User Id
                            <span class="starclr">*</span>
                          </label>

                          <input
                            type="text"
                            required
                            id="userId"
                            class="form-control hpl-enq-frm phonestyle"
                            name="userId"
                            formControlName="userId"
                          />

                          @if (
                            getError(loginForm.get("userId"), "User Id");
                            as errorMsg
                          ) {
                            <span class="err-msg text text-danger">
                              {{ errorMsg }}
                            </span>
                          }
                        </div>

                        <br />

                        <!-- PASSWORD -->
                        <div class="form-group ytb-lgn">
                          <label
                            for="password"
                            class="black left form-label fmlab-bg"
                          >
                            Password
                            <span class="starclr">*</span>
                          </label>

                          <input
                            type="password"
                            required
                            id="password"
                            class="form-control hpl-enq-frm phonestyle"
                            name="password"
                            formControlName="password"
                          />

                          @if (
                            getError(loginForm.get("password"), "Password");
                            as errorMsg
                          ) {
                            <span class="err-msg text text-danger">
                              {{ errorMsg }}
                            </span>
                          }
                        </div>

                        <!-- FORGOT PASSWORD -->
                        <div class="row gap-5 mt-10">
                          <div class="pay-5"></div>

                          <div class="pay-5 text-right">
                            <div class="nav text-right d-inline-block">
                              <button
                                type="button"
                                class="btn btn-link hyperLinkButtonColor text-orange text-dark cursor font13 forgotpassword"
                                (click)="loadComponent('forgotpassword')"
                              >
                                Forgot password?
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- PRIVACY -->
                        <p class="ml-1-enq mb-15">
                          By signing in, you agree to our

                          <button
                            type="button"
                            (click)="navigateToPrivacyPolicy('privacy')"
                            class="customlinks btn btn-link p-0 border-0"
                          >
                            Privacy Policy
                          </button>

                          and

                          <button
                            type="button"
                            (click)="navigateToPrivacyPolicy('terms')"
                            class="customlinks btn btn-link p-0 border-0"
                          >
                            Terms of Service</button
                          >. Your journey is secure and ready to unfold. Bon
                          voyage!
                        </p>

                        <!-- LOGIN BUTTON -->
                        <div class="mt-10">
                          <button
                            type="submit"
                            class="btn btn-primary btn-block font15"
                          >
                            Login
                          </button>
                        </div>

                        <!-- SIGN UP -->
                        <div>
                          <div class="form-group mt-2">
                            <div role="alert">
                              <span class="text-black">
                                New to Your Travel Booking?
                                <br />

                                Join the adventure! Click here to create your
                                account and unlock a world of exclusive travel
                                benefits.
                              </span>

                              <button
                                #signin
                                type="button"
                                class="font600 text-orange text-underline cursor customlinks btn btn-link p-0"
                                (click)="navigateToSignup()"
                              >
                                Create an account
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  }

                  <!-- ================================================= -->
                  <!-- FORGOT PASSWORD BACK SIDE -->
                  <!-- ================================================= -->

                  <div
                    class="card__face card__face--back"
                    #forgotpasswordElement
                  >
                    <ng-template #load></ng-template>
                  </div>
                </div>
              }

              <!-- ===================================================== -->
              <!-- RESET PASSWORD CARD -->
              <!-- ===================================================== -->

              @if (showreset() && !showlogin()) {
                <div class="card">
                  <form
                    [formGroup]="resetForm"
                    class="form-login"
                    (ngSubmit)="resetlogin()"
                  >
                    <!-- LOGO -->
                    <div class="text-center">
                      <br />

                      <img
                        src="assets/images/logo-white.png"
                        class="center"
                        alt="logo"
                        title="logo"
                        width="200"
                      />
                    </div>

                    <!-- TITLE -->
                    <div class="row pl-20 pr-20 ytb-login">
                      <div class="text-center col-md-12">
                        <h4 class="font24 font600 opensans mt-10">
                          Update Password
                        </h4>
                      </div>
                    </div>

                    <div class="form-inner" style="height: 450px">
                      <!-- ERROR -->
                      @if (showErrorMessage() && errorMessageInfo().length) {
                        @for (err of errorMessageInfo(); track $index) {
                          <div class="row alert alert-danger">
                            {{ err }}
                          </div>
                        }
                      }

                      <!-- SUCCESS -->
                      @if (showSuccessMessage() && errorMessageInfo().length) {
                        @for (err of errorMessageInfo(); track $index) {
                          <div class="alert alert-success">
                            {{ err }}
                          </div>
                        }
                      }

                      <br />

                      <!-- NEW PASSWORD -->
                      <div class="form-group ytb-lgn">
                        <label class="black">
                          New Password
                          <span class="red">*</span>
                        </label>

                        <input
                          formControlName="password"
                          id="login_password"
                          class="form-control"
                          placeholder="New Password"
                          type="password"
                        />

                        @if (
                          resetForm.get("password")?.touched &&
                          resetForm.get("password")?.hasError("required")
                        ) {
                          <span class="err-msg text text-danger">
                            New Password is required
                          </span>
                        }
                      </div>

                      <br />

                      <!-- CONFIRM PASSWORD -->
                      <div class="form-group ytb-lgn">
                        <label class="black">
                          Confirm Password
                          <span class="red">*</span>
                        </label>

                        <input
                          formControlName="confirmpassowrd"
                          id="login_confirm_password"
                          class="form-control"
                          placeholder="Confirm Password"
                          type="password"
                        />

                        @if (
                          resetForm.get("confirmpassowrd")?.touched &&
                          resetForm.get("confirmpassowrd")?.hasError("required")
                        ) {
                          <span class="err-msg text text-danger">
                            Confirm Password is required
                          </span>
                        }

                        @if (
                          resetForm.get("confirmpassowrd")?.touched &&
                          resetForm
                            .get("confirmpassowrd")
                            ?.hasError("mustmatch")
                        ) {
                          <span class="text text-danger">
                            Passwords must match
                          </span>
                        }
                      </div>

                      <br />

                      <!-- UPDATE PASSWORD -->
                      <div class="row gap-5 mt-10">
                        <button
                          type="submit"
                          class="btn btn-primary btn-block btn-round"
                        >
                          Update Password
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              }

              <!-- SPINNER -->
              <ngx-spinner
                bdcolor="rgba(255,255,255, 0.9)"
                [fullScreen]="false"
                type="ball-clip-rotate-multiple"
                size="medium"
              >
              </ngx-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
